/** Isotipo oficial de MarTech (extraído de «Logo MarTech.svg»). El logo completo está en /brand/logo-martech.svg. */
export function Logo({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 128.241 128.241" fill="none" className={className} role="img" aria-label="MarTech">
      <title>MarTech</title>
      <path
        d="M64.1207 128.241C99.5335 128.241 128.241 99.5335 128.241 64.1207C128.241 28.7078 99.5335 0 64.1207 0C28.7078 0 0 28.7078 0 64.1207C0 99.5335 28.7078 128.241 64.1207 128.241Z"
        fill="#89C808"
      />
      <path
        d="M106.779 41.8443C101.43 42.4004 102.359 50.0531 107.547 49.6835C112.617 49.3212 112.028 41.2989 106.779 41.8443Z"
        fill="white"
      />
      <path
        d="M92.378 41.8228C91.2586 41.7152 90.498 41.6649 89.5077 41.6757C85.7836 41.7116 81.2738 41.4102 77.7291 41.8551C72.7672 42.4758 72.7564 49.2925 78.1094 49.8594C81.1949 50.1859 84.7037 49.6692 87.8358 49.8845C88.1982 49.9132 88.3632 50.1787 88.4673 50.498L88.5785 88.3347C89.1059 90.8676 91.2622 92.2776 93.7951 91.5098C96.1953 90.7815 96.6044 88.9625 96.6618 86.7022C97.0134 73.4956 96.5649 60.4182 96.6618 46.8672C96.5936 44.0149 95.3343 42.1098 92.3744 41.8228H92.378Z"
        fill="white"
      />
      <path
        d="M64.3359 41.8586C62.2335 41.2451 60.7374 42.0882 59.4314 43.6811C54.1789 50.0889 49.6978 58.3838 44.5386 65.0894C44.2946 65.4087 43.5986 66.5424 43.247 66.4671L26.5316 42.9313C24.2785 40.61 21.0566 41.5177 19.7722 44.2803L19.6897 88.7543C21.0531 92.8731 27.3568 92.4246 27.3496 87.9363C27.3388 78.7624 27.4716 68.2072 27.3424 60.1418L27.3568 58.0143L39.8027 75.9065C41.9985 78.4502 44.2946 78.6117 46.5262 75.9962C50.0494 71.8631 53.9744 65.7208 57.1927 61.1464C59.9266 57.2573 63.8552 52.281 66.1155 48.2914C67.5039 45.8374 67.4178 42.7555 64.3288 41.855L64.3359 41.8586Z"
        fill="white"
      />
      <path
        d="M62.3734 83.9468C56.4858 84.711 59.0152 93.8885 64.7557 91.3053C68.5551 89.5939 67.0841 83.3369 62.3734 83.9468Z"
        fill="white"
      />
    </svg>
  );
}
